/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum CalenderEventCategories {
  Religious = 0,
  National = 1,
  International = 2,
  Ancient = 3,
  Astronomical = 4,
  Other = 5
}
